module.exports = __webpack_public_path__ + "static/media/TRX.60b67e43.svg";